export const frameCostPerEditedPhoto = 10;

export const tool = "ai-photo-editor";
